import { render, staticRenderFns } from "./AdminCard.vue?vue&type=template&id=43581878"
import script from "./AdminCard.vue?vue&type=script&lang=js"
export * from "./AdminCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports